import agentContractAgreementsDictionary from '@features/agent-contract-agreements/i18n/ru/agent-contract-agreements.dic.json';

export const agentContractAgreements = {
  AGENT_CONTRACT_AGREEMENTS: agentContractAgreementsDictionary,
};

export const agentContractAgreementsNamespaces = ['AGENT_CONTRACT_AGREEMENTS'];
